import styled from '@emotion/styled';

const StyledFormWrapper = styled.div`
  margin-bottom: 20px;
  margin-top: 16px;
`;

export { StyledFormWrapper };
